//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TransientObject.js";
import "../no/NXObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["name"],"GetIntegerCharacteristic",{R_:{value:''}},1,0],[["name","value"],"SetCharacteristic",{},2,0],[["name"],"GetRealCharacteristic",{R_:{value:''}},1,0],[["name","value"],"SetCharacteristic1",{},2,0],[["name"],"GetStringCharacteristic",{R_:{value:''}},1,0],[["name","value"],"SetCharacteristic2",{},2,0],[["name","value","type"],"SetCharacteristic3",{},3,0],[["type","num_titles"],"GetCharacteristicTitlesByType",{R_:{titles:""}},1,0],[["name","type"],"DeleteCharacteristic",{},2,0]],[]];
SPLM.Routing.CharacteristicList = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.CharacteristicList";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.CharacteristicList.CharacteristicInformation = class{
    constructor(type,name){
        this.type=type;this.name=name;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
};

export default SPLM;